/* eslint-disable parog-web/no-glint-expect-error-directive */
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import changesetGet from 'ember-changeset/helpers/changeset-get';
import FormyComponent from '../formy';
import FormyField from './field';

type Args =
  | { parent: FormyComponent; key: string }
  | {
      parent: FormyField;
      key: never;
    };

interface Signature {
  Args: Args;
  Element: HTMLInputElement;
}

export default class FormyInputComponent extends Component<Signature> {
  get changeset(): EmberChangeset {
    return this.#formy.args.changeset;
  }

  get errorId(): FormyField['errorId'] {
    return this.args.parent instanceof FormyField
      ? this.args.parent.errorId
      : undefined;
  }

  get id(): FormyField['id'] | undefined {
    return this.args.parent instanceof FormyField
      ? this.args.parent.id
      : undefined;
  }

  get key(): string {
    return this.args.parent instanceof FormyField
      ? this.args.parent.args.key
      : this.args.key;
  }

  get #formy(): FormyComponent {
    if (this.args.parent instanceof FormyComponent) return this.args.parent;
    return this.args.parent.args.formy;
  }

  setValue = ({ target: input }: { target: HTMLInputElement }): void => {
    this.changeset.set(this.key, input.value);
  };

  <template>
    <input
      id={{this.id}}
      aria-invalid={{if this.errorId true false}}
      aria-errormessage={{this.errorId}}
      value={{changesetGet this.changeset this.key}}
      {{! @glint-expect-error }}
      {{on 'input' this.setValue}}
      ...attributes
    />
  </template>
}
